import { PrimeIcons } from "@primevue/core/api";
import { ApiService } from "./api.service";
import { GEMS } from "./gems";
import UserGemsService from "./user.gems.service";
export default class GemsService extends ApiService {
  template = "defaultTemplate";
  namespace = "gem";
  icon = "Document";
  favicon = "Menu";
  action = "action";
  Width = 1190;
  singular = this.terminology.gems.singular;
  plural = this.terminology.gems.plural;
  vowel = this.terminology.gems.vowel;
  columns = [
    {
      header: this.t("title"),
      icon: "Tag",
      field: "title",
    },
    {
      header: this.t("description"),
      icon: "Notebook",
      field: "description",
    },
    {
      header: "",
      icon: "Question",
      field: "is_hidden",
      template: (data) => {
        return data.is_hidden > 0 ? this.t("yes") : this.t("no");
      },
    },
  ];
  navItems = [
    {
      key: "listing",
      label: this.t("viewAllEntities", { entity: this.plural }),
      icon: "Bullets",
    },
    {
      key: "bookmark",
      label: this.t("viewMyBookmarks"),
      icon: "Bookmark",
    },
  ];
  gemItems = [
    {
      key: "listng",
      label: this.t("viewBookmarkEntity", { entity: "Gems" }),
      icon: PrimeIcons.LIST,
    },
    {
      key: "listing",
      label: this.t("viewBookmarkEntity", { entity: "Gems" }),
      icon: PrimeIcons.LIST,
    },
  ];

  listingFooterControls = [
    {
      key: "cancel",
      label: this.t("cancel"),

      icon: PrimeIcons.PLUS_CIRCLE,
      action: () => {},
    },
    {
      key: "add",
      label: this.t("addSelectedGEMs"),
      icon: PrimeIcons.PLUS_CIRCLE,
      action: (context, selectedItems, btn, event) => {
        let oldLabel = btn.label;
        selectedItems.forEach((item) => {
          btn.label = "adding gem...";
          let userGemsService = new UserGemsService();
          let usergem = {
            tab_id: event,
            gem_id: item.id,
            data: "",
          };
          userGemsService.post(usergem).then(() => {
            context.$toast.add({
              severity: "success",
              summary: "Gem Added!",
              life: 3000,
              detail: "Gem:" + item.title + " added successfuly!",
            });
            // context.emitter.emit("notify", {
            //   severity: "success",
            //   summary: "Gem Added!",
            //   life: 3000,
            //   detail: "Gem:" + item.title + " added successfuly!",
            // });
            context.emitter.emit("notify");
            btn.label = oldLabel;
            this.context.emitter.emit("close-window", event);
          });
        });
      },
    },
  ];
  filterItems = [{ name: "Section", value: "2" }];
  permissions = [
    {
      key: "accounting",
      display_name: "Accounting",
      icon: "SectionStar",
      section: 2,
    },

    {
      key: "assets",
      display_name: "Assets",
      icon: "Home",
      section: 3,
    },
    {
      key: "billing",
      display_name: "Billing",
      icon: "SectionMoney",
      section: 4,
    },
    {
      key: "crm",
      display_name: "CRM",
      icon: "Property",
      section: 5,
    },
    {
      key: "file",
      display_name: "Files",
      icon: "Folder",
      section: 6,
    },
    {
      key: "job",
      display_name: "Jobs",
      icon: "Briefcase",
      section: 7,
    },
    {
      key: "payable",
      display_name: "Payables",
      icon: "SectionFile",
      section: 8,
    },
    {
      key: "payroll",
      display_name: "Payroll",
      icon: "SectionUsers",
      section: 9,
    },
    {
      key: "report",
      display_name: "Reports",
      icon: "SectionGraph",
      section: 10,
    },
    {
      key: "time",
      display_name: "Time",
      icon: "SectionClock",
      section: 11,
    },
    {
      key: "tools",
      display_name: "Tools",
      icon: "Wrench",
      section: 12,
    },
  ];
  listMenuItems = [
    {
      key: "edit",
      label: "Polion Admins:Edit this GEM...",
      icon: PrimeIcons.PENCIL,
    },

    {
      key: "bookmark",
      label: "bookmarkThisEntity",
      icon: PrimeIcons.BOOKMARK,
    },
  ];
  getGem(gemId) {
    let item = GEMS.find((item) => item.id === gemId);
    return item;
  }
  constructor() {
    super("gems");
  }
}
